/*eslint-disable no-unused-vars */
import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, Modal, Button } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { DistanceFilter } from './DistanceFilter';
import { GenderFilter } from './GenderFilter';
import { ProviderFilter } from './ProviderFilter';
import { LanguageFilter } from './LanguageFilter';
import {
  setSearchProviderFilters,
  resetSearchProviderFilters,
  setShowAllFiltersPanel,
  setProviderType,
  setSearchParamsForUI,
  setSearchProviderParams,
} from '../../../../../redux/member/priceCompareSlice';
//import {
//getPriceComaperFilters,
//searchProviders,
//} from '../../../../../redux/member/api-calls/priceCompare';
import { BestMatchFilter } from './BestMatchFilter';
import GenericButton from '../../../../../Components/GenericButton/GenericButton';
import AllFilterOptions from './AllFilterOptions';
import './InLineSearchFilter.scss';
import { t } from 'i18next';
import { MAXIMUM_FIND_PRICE_COMPARE_RADIUS } from 'src/constants';

const InLineSearchFilter = (props) => {
  const sortByRef = useRef();
  const providerRef = useRef();
  const distanceRef = useRef();
  const languageRef = useRef();
  //const resetFiltersRef = useRef();
  const { searchParamsForUI } = useSelector(({ priceCompare }) => priceCompare);
  const [showAllFilters, setShowAllFilters] = useState(false);
  const typesOfSpecialtyData = '';
  const dispatch = useDispatch();
  const allFilters = useSelector(
    ({ priceCompare }) => priceCompare.searchProviderParams.filters,
  );
  const { Provider, Gender, maximumradius, spokenlanguages } = allFilters;
  const filtersValuesList = useSelector(
    ({ priceCompare }) => priceCompare.filtersValuesList,
  );
  const { networksData } = useSelector(
    ({ priceCompare }) => priceCompare.searchParamsForUI,
  );
  const isExternalProvider = networksData?.ProviderDirectory === 'R';

  const onChangeHandler = async (paramName, value) => {
    if (paramName !== 'spokenlanguages') {
      dispatch(setSearchProviderFilters({ [paramName]: value }));
    }
    if (paramName === 'Provider') {
      if (value === 'facility') {
        dispatch(
          setSearchParamsForUI({
            ...searchParamsForUI,
            providerByData: 'facility-type',
            typesOfSpecialtyData: null,
            filters: { providerByData: 'facility-type' },
          }),
        );
        dispatch(
          setSearchProviderParams({
            pagenumber: 1,
            speciality: null,
            facilityname: null,
            DoctorByType: null,
            DoctorByName: null,
            AcceptingNewPatients: false,
            Network: searchParamsForUI?.networksData?.value,
            filters: {
              Provider: 'facility',
              maximumradius: MAXIMUM_FIND_PRICE_COMPARE_RADIUS,
              Gender: '',
            },
          }),
        );
      } else {
        dispatch(
          setSearchParamsForUI({
            ...searchParamsForUI,
            typesOfSpecialtyData: null,
            providerByData: 'doctor-type',
            filters: { providerByData: 'doctor-type' },
          }),
        );
        dispatch(
          setSearchProviderParams({
            pagenumber: 1,
            facilityname: null,
            DoctorByType: null,
            DoctorByName: null,
            AcceptingNewPatients: false,
            Network: searchParamsForUI?.networksData?.value,
            filters: {
              Provider: 'doctor',
              maximumradius: MAXIMUM_FIND_PRICE_COMPARE_RADIUS,
              Gender: '',
            },
          }),
        );
      }
    }
    if (paramName === 'spokenlanguages') {
      if (value) {
        const valuesToSave = value.map((val) => {
          return val.value;
        });
        dispatch(setSearchProviderFilters({ spokenlanguages: valuesToSave }));
      } else {
        dispatch(setSearchProviderFilters({ spokenlanguages: null }));
      }
    }
  };

  const applyAllFilters = (selectedOptions) => {
    dispatch(setSearchProviderFilters(selectedOptions));
    setShowAllFilters(false);
  };

  const resetFilters = () => {
    dispatch(resetSearchProviderFilters());
    props.onChangeBestMatchEvent('');
    props.onChangeGenderEvent('');
    props.onChangeDistanceEvent('');
    props.onChangeLanguageEvent([]);
    props.onApplyFiltersPanelClick(false);
    props.onResetFiltersClick(true);
  };

  useEffect(() => {
    if (props.searchFilterBestMatchClicked !== '') {
      sortByRef && sortByRef?.current && sortByRef?.current?.focus();
    }
  }, [props.searchFilterBestMatchClicked]);

  useEffect(() => {
    if (props.searchGenderFilterClicked !== '') {
      providerRef && providerRef?.current && providerRef?.current?.focus();
    }
  }, [props.searchGenderFilterClicked]);

  useEffect(() => {
    if (props.searchDistanceFilterClicked !== '') {
      distanceRef && distanceRef?.current && distanceRef?.current?.focus();
    }
  }, [props.searchDistanceFilterClicked]);

  useEffect(() => {
    if (props.searchLanguageFilterClicked.length) {
      languageRef && languageRef?.current && languageRef?.current?.focus();
    }
  }, [props.searchLanguageFilterClicked]);

  return (
    <>
      <Row className="inline-filter-bar">
        {!isExternalProvider && (
          <Col md={2} xs={6} className="sort-by-column">
            <div className="filter-data">
              <Row className="align-items-center">
                <Col xs={5} className="pr-0">
                  <p>
                    <b>{t('find_provider.sort_by')} : </b>
                  </p>
                </Col>
                <Col xs={7} className="p-0" ref={sortByRef} tabIndex={-1}>
                  <BestMatchFilter
                    onChangeBestMatchEvent={(val) => {
                      props.onChangeBestMatchEvent(val);
                      props.onResetFiltersClick(false);
                      props.onApplyFiltersPanelClick(false);
                    }}
                  />
                </Col>
              </Row>
            </div>
          </Col>
        )}
        <Col xs={6} className="d-block d-md-none">
          <div className="filter-data text-right">
            <GenericButton
              onClick={() => setShowAllFilters(!showAllFilters)}
              variant="secondary"
            >
              {t('find_provider.filter')}
            </GenericButton>
          </div>
        </Col>
        <Col md={isExternalProvider ? 12 : 10} className="d-none d-md-block">
          <div className="filter-data">
            <Row>
              <Col md={9}>
                <Row>
                  <Col md={3}>
                    <Row className="align-items-center">
                      <Col xs={6} className="pr-0">
                        <p>
                          <b>Provider : </b>
                        </p>
                      </Col>
                      <Col
                        xs={6}
                        className="p-0"
                        ref={providerRef}
                        tabIndex={-1}
                      >
                        <ProviderFilter
                          value={Provider}
                          onChange={(event) => {
                            onChangeHandler('Provider', event.value);
                            props.onChangeGenderEvent(event.value);
                            props.onResetFiltersClick(false);
                            props.onApplyFiltersPanelClick(false);
                          }}
                          inputClassName="height-32 search-filter-component"
                        />
                      </Col>
                    </Row>
                  </Col>
                  <Col md={3} className="p-0 ml-2">
                    <Row className="align-items-center">
                      <Col xs={5} className="pr-0">
                        <p>
                          <b>Distance : </b>
                        </p>
                      </Col>
                      <Col
                        xs={6}
                        className="p-0"
                        ref={distanceRef}
                        tabIndex={-1}
                      >
                        <DistanceFilter
                          value={maximumradius}
                          onChange={(event) => {
                            onChangeHandler('maximumradius', event.value);
                            props.onChangeDistanceEvent(event.value);
                            props.onResetFiltersClick(false);
                            props.onApplyFiltersPanelClick(false);
                          }}
                          inputClassName="height-32 search-filter-component"
                        />
                      </Col>
                    </Row>
                  </Col>
                  {Provider !== 'facility' && !isExternalProvider && (
                    <Col md={5}>
                      <Row className="align-items-center">
                        <Col xs={4} className="pr-0">
                          <p>
                            <b>Language : </b>
                          </p>
                        </Col>
                        <Col
                          xs={7}
                          className="p-0"
                          ref={languageRef}
                          tabIndex={-1}
                        >
                          <LanguageFilter
                            value={spokenlanguages}
                            onChange={(event) => {
                              onChangeHandler('spokenlanguages', event);
                              props.onChangeLanguageEvent(event);
                              props.onResetFiltersClick(false);
                              props.onApplyFiltersPanelClick(false);
                            }}
                            inputClassName="height-32 search-filter-component"
                            data={filtersValuesList.ListOfDoctorLanguages}
                          />
                        </Col>
                      </Row>
                    </Col>
                  )}
                </Row>
              </Col>
              <Col md={3} className="text-right">
                <Row>
                  <Col
                    md={6}
                    className="p-1"
                    //ref={resetFiltersRef}
                    //tabIndex={-1}
                  >
                    <GenericButton
                      id="reset-filter-button"
                      variant="link"
                      onClick={() => {
                        resetFilters();
                      }}
                    >
                      {t(
                        'member.price_comparison.provider_container.reset_filters',
                      )}
                      <span className="sr-only">
                        Click to reset the filters that you have applied.
                      </span>
                    </GenericButton>
                  </Col>
                  <Col md={6} className="text-nowrap">
                    <GenericButton
                      id="show-all-filters-button"
                      className="show-all-filter show-all-filters-button"
                      onClick={() => setShowAllFilters(true)}
                      variant="secondary"
                    >
                      {t(
                        'member.price_comparison.provider_container.show_all_filters',
                      )}{' '}
                      <span className="sr-only">
                        Click to open the filters panel for additional filters.
                      </span>
                    </GenericButton>
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        </Col>
      </Row>
      <AllFilterOptions
        isVisible={showAllFilters}
        onHide={() => {
          setShowAllFilters(false);
        }}
        //filters={allFilters}
        onApply={applyAllFilters}
        onResetFiltersClick={props.onResetFiltersClick}
        onApplyFiltersPanelClick={props.onApplyFiltersPanelClick}
      />
    </>
  );
};

export default InLineSearchFilter;
